import { FontSize, isFontSizeToken } from '../utils/fontSizeProps';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import { BreakpointProp } from '../utils/responsiveProp';
import { CSSObject } from '../theming';
import { font } from '../utils';

const convertSizeTokensToRem = (value: FontSize) =>
  isFontSizeToken(value) ? tokens.size.font[value] : value;

export function getResponsiveCapsizes(
  responsiveProps: BreakpointProp<'fontSize' | 'lineHeight', FontSize>
) {
  const { fontSize, lineHeight } = responsiveProps;
  const result: CSSObject = {
    ...responsiveProps,
    ...font({
      fontSize: convertSizeTokensToRem(fontSize),
      lineHeight: convertSizeTokensToRem(lineHeight),
    }),
  };

  Object.keys(responsiveProps).forEach((key) => {
    const value = responsiveProps[key];
    if (typeof value !== 'object') return;
    const { fontSize, lineHeight } = value;

    result[key] = {
      ...value,
      ...font({
        fontSize: convertSizeTokensToRem(fontSize),
        lineHeight: convertSizeTokensToRem(lineHeight),
      }),
    };
  });

  return result;
}
